var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"one-menu-box"},[(!_vm.isIframe)?_c('Header'):_vm._e(),_c('div',{class:['content-box-page', {'no-header': _vm.isIframe}]},[_c('leftMenu',{attrs:{"paths":_vm.paths}}),_c('div',{staticClass:"router-view-box float-left"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }